"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includesAll = includesAll;
/**
 * Sprawdza czy tablica zawiera wszystkie elementy z tablicy requiredArr
 * @param arr
 * @param requiredArr
 * @returns
 */
function includesAll(arr, requiredArr) {
    if (!Array.isArray(arr) || !Array.isArray(requiredArr)) {
        return false;
    }
    for (const element of requiredArr) {
        if (!arr.includes(element)) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=includesAll.js.map